module.exports = __webpack_public_path__ + "img/202602_02.04612090.png";